import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { host } from "@Api";
import { fetchKindsModelsCompare } from "@Services/article";
const { c } = host;
const MenuGuide = React.memo(() => {
  const [modelsCompareData, setModelsCompareData] = useState({ name: "", ids: "" });
  // 执行顺序导致没有获取到window.articleType
  const type = window.articleType || window.type_name;

  const getGuide = () => {
    switch (type) {
      case "國內車訊":
        return "覆蓋全台300+車款，30秒找到您的命定車！點擊查看購車菜單，搶占最佳入手時機，>>立即了解<<";
      case "新車上市":
        return "新車上市怕買貴？查看同級車款購車菜單，提前掌握合理成交價！>>立即了解<<";
      case "排行報告":
        return "大家都在買的車，用多少錢能入手？點擊查看購車菜單，獲取真實成交行情！>>立即了解<<";
      case "優惠快訊":
        return "這波優惠真的划算嗎？用購車菜單，一鍵比對全台真實車主成交價！>>立即了解<<";
      // case "PK比較":
      //   return "還在糾結選哪台？用購車菜單，一鍵比對全台真實車主成交價！>>立即了解<<";
      case "集評導購":
        return "還在糾結選哪台？用購車菜單，一鍵比對全台真實車主成交價！>>立即了解<<";
      case "買車大補貼":
        return "還在糾結選哪台？用購車菜單，一鍵比對全台真實車主成交價！>>立即了解<<";
      case "買車大補帖":
        return "還在糾結選哪台？用購車菜單，一鍵比對全台真實車主成交價！>>立即了解<<";
      case "超級測試":
        return "看完評測還猶豫？心動不如行動，用購車菜單，一鍵比對全台車主成交價！>>立即了解<<";
      case "搶先試駕":
        return "看完評測還猶豫？心動不如行動，用購車菜單，一鍵比對全台車主成交價！>>立即了解<<";
      default:
        return "";
    }
  };

  const fetchModelsCompareData = async () => {
    try {
      const res: { status, data } = await fetchKindsModelsCompare({
        kindIds: window.RELATED_KIND_IDS || '',
        uniqueKindId: "1",
      });
      if (res.status === 12000) {
        const brandNames = (typeof window !== "undefined" ? window.NC_BRAND_NAME : "")?.split(",") || [];
        const kindNames = (typeof window !== "undefined" ? window.NC_KIND_NAME : "")?.split(",") || [];

        const obj = {
          name: !!brandNames.length && !!kindNames.length ?
            brandNames.map((brand, index) => `${brand} ${kindNames[index] || ""}`)
              .join(brandNames.length === 2 ? '和' : '、')
              .replace(/、([^、]*)$/, '和$1') : "",

          ids: !!res.data.list.length ? res.data.list.map(item => item.modelYearInfo).map(ii => ii.myid).join(",") : "",
        }
        setModelsCompareData(!!res.data.list.length ? obj : { name: "", ids: "" });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchModelsCompareData();
  }, [window.RELATED_KIND_IDS]);


  if (!!window.article && window.article.id == 19930) {
    return <a
      href={`${c}/pk/comprehensive?myids=`}
      target='_blank'
      style={{ color: "#3264ff", display: "inline-block", padding: "0 30px 20px 30px" }}
    >
      {`>>馬上體驗PK比較<<`}
    </a>;
  }

  return (
    <div className="px-30 text-[17px] pb-20">
      {type === "PK比較" ? (
        <div className="flex flex-col gap-14">
          <p style={{ margin: "0", color: "#1B1B1B", fontWeight: "600", lineHeight: "24px" }}>還在糾結選哪台？給您一些小建議，更好的做出購車決策</p>
          {!!modelsCompareData.ids && <p style={{ margin: "0", color: "#333333", lineHeight: "24px" }}>
            1.進一步PK比較{modelsCompareData.name}
            <a
              href={`${c}/pk/comprehensive?myids=${modelsCompareData.ids}`}
              target='_blank'
              id='tracking-pk-compare'
              className="inline-block text-[#3264ff] hover:text-[#3264ff] pl-4"
            >
              {`>>查看完整PK報告<<`}
            </a>
          </p>}
          <p style={{ margin: "0", color: "#333333", lineHeight: "24px" }}>
            {!!modelsCompareData.ids ? 2 : 1}.用購車菜單，一鍵比對全台真實車主成交價！
            <a
              href={`${c}/menu`}
              target='_blank'
              id='tracking-menu-guide'
              data-type={type}
              data-id={window?.article?.id}
              className="inline-block text-[#3264ff] hover:text-[#3264ff] pl-4"
            >
              {`>>立即了解購車菜單<<`}
            </a>
          </p>
        </div>
      ) : (
        <>
          {!!getGuide() && <a
            href={`${c}/menu`}
            target='_blank'
            id='tracking-menu-guide'
            data-type={type}
            data-id={window?.article?.id}
            style={{ color: "#3264ff", display: "inline-block" }}
          >
            {getGuide()}
          </a>}
        </>
      )}
    </div>
  );
});

const $app = document.getElementById("menu-guide");
$app && ReactDOM.render(<MenuGuide />, $app);
